// ** React Imports
import { createContext, useState, useEffect } from 'react';

//grid  L10n provider
import { L10n, setCulture } from '@syncfusion/ej2-base';

// ** Intl Provider Import
import { IntlProvider } from 'react-intl';

// ** RSuite Provider Import
import { CustomProvider } from 'rsuite';
import esES from 'rsuite/locales/es_ES';
import enUS from 'rsuite/locales/en_US';

// ** Moment.js locale
import moment from 'moment';
import 'moment/locale/es';

// ** Luxon locale
import { Settings } from 'luxon';

import { IntlGlobalProvider } from './IntlGlobalProvider';

// ** Core Language Data
import messagesEn from '@assets/data/locales/en.json';
import messagesEs from '@assets/data/locales/es.json';
import messageEsGrid from 'views/components/Table/i18n/es.json';
import messageEsDateTimePicker from 'views/components/TableDateTimePicker/i18n/es.json';

// ** User Language Data
import userMessagesEn from '@src/assets/data/locales/en';
import userMessagesEs from '@src/assets/data/locales/es';

// ** Menu msg obj
const menuMessages = {
  es: { ...messagesEs, ...userMessagesEs },
  en: { ...messagesEn, ...userMessagesEn }
};

// ** Create Context with default value
const Context = createContext<any>(null);

const IntlProviderWrapper = ({ children }) => {
  // ** States
  const localStorageLang = localStorage.getItem('lang') ?? 'es';
  const [locale, setLocale] = useState(localStorageLang);
  const [messages, setMessages] = useState(menuMessages[localStorageLang]);

  // useEffect(() => {
  //   if (appIntl() != null) {
  //     setLocale(appIntl().locale);
  //     setMessages([appIntl().locale]);
  //   }
  // }, []);
  // ** Switches Language
  const switchLanguage = (lang) => {
    setLocale(lang);
    setMessages(menuMessages[lang]);
    //Save language in local storage
    localStorage.setItem('lang', lang);
  };

  // ** Set moment.js and luxon locale globally
  useEffect(() => {
    moment.locale(locale);
    Settings.defaultLocale = locale;
    document.documentElement.lang = locale;
  }, [locale]);

  // Documentación con todos los prefijos
  // https://ej2.syncfusion.com/react/documentation/grid/global-local/

  // Set the culture for Syncfusion components - modern approach
  setCulture(locale === 'es' ? 'es-US' : 'en-US');

  L10n.load({
    'es-US': { ...messageEsGrid, ...messageEsDateTimePicker },
    'en-US': {} // Add English translations if needed
  });

  // RSuite locale mapping
  const rsuiteLocale = locale === 'es' ? esES : enUS;

  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <CustomProvider locale={rsuiteLocale}>
        <IntlProvider locale={locale} messages={messages} defaultLocale="es">
          <IntlGlobalProvider>{children}</IntlGlobalProvider>
        </IntlProvider>
      </CustomProvider>
    </Context.Provider>
  );
};

export { Context as IntlContext, IntlProviderWrapper };
